module.exports = __webpack_public_path__ + "media/images/icon-3arrows-3dd1879aa7ea824ca9109742f8ff83e3.svg";